import { CircleAlert, TrendingDown, TrendingUp } from "lucide-react";

const getLeakageData = (apiData) => {
  if (!apiData) return [];

  return [
    {
      id: 1,
      type: "danger",
      title: "Maximum Leakage Stage",
      heading: apiData?.maximumLeakageStage?.stage,
      description: `${apiData?.maximumLeakageStage?.dropOffPercent}% dropout rate | ₹${apiData?.maximumLeakageStage?.costImpact} cost impact`,
      icon: CircleAlert,
    },
    {
      id: 2,
      type: "warning",
      title: "Highest Cost Drop Reason",
      heading: apiData?.highestCostDropReason?.reason,
      description: `${apiData?.highestCostDropReason?.customers} customers | ₹${apiData?.highestCostDropReason?.costImpact} cost impact`,
      icon: TrendingDown,
    },
    {
      id: 3,
      type: "success",
      title: "Lowest Impact Reasons",
      list: apiData?.lowestImpactReasons?.map(
        (item) => `${item.reason}: ₹${item.costImpact}`
      ),
      icon: TrendingUp,
    },
  ];
};

const LeakageInsights = ({ data }) => {
  const leakageData = getLeakageData(data);

  return (
    <div className="leakage-container">
      <h5 style={{ fontSize: window.innerWidth >=1800 ? '20px':"14px" , }}>
        Leakage Insights and recommendations
      </h5>

      <div className="card-wrapper">
        {leakageData.map((item) => {
          const Icon = item.icon;

          return (
            <div key={item.id} className={`leakage-card ${item.type}`}>
              <div>
                <Icon size={24} />
              </div>

              <div className="content">
                <p className="card-title">{item.title}</p>

                {item.heading && (
                  <h3 className="card-heading">{item.heading}</h3>
                )}

                {item.description && (
                  <p className="card-desc">{item.description}</p>
                )}

                {item.list && (
                  <ul className="list">
                    {item.list.map((reason, i) => (
                      <li key={i}>{reason}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LeakageInsights;
